
// import React, { useState, useEffect, useRef } from "react";
// import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaBars, FaTimes } from "react-icons/fa";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import logo from "../pages/modules/Component/maamaaslog.png";
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import { Link } from 'react-router-dom';
// import SliderComponent from '../pages/modules/Cloudkitchen/SliderComponent.js';
// import { Paper, MenuItem, Slide, IconButton } from "@mui/material";
// import LogoutIcon from "@mui/icons-material/Logout";
// import PersonIcon from "@mui/icons-material/Person";
// import { FaMapMarkerAlt } from "react-icons/fa";
// import { FaSearch } from "react-icons/fa";
// import { useParams } from "react-router-dom";

// // ✅ FIXED: Single source of truth for localStorage keys
// // At the very top after imports (line ~20)
// const getStorageKeys = (userId) => ({
//     SAVED_KEY: `savedAddresses_${userId}`,
//     CURRENT_KEY: `currentLocation_${userId}`,
//     SELECTED_KEY: `selectedAddress_${userId}`,
// });

// export default function Cloudnavbar({ showLogin, setShowLogin }) {
//     const [index, setIndex] = useState(0);
//     const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
//     const [scrolled, setScrolled] = useState(false);
//     const [showMobileMenu, setShowMobileMenu] = useState(false);
//     const [showPopup, setShowPopup] = useState(false);
//     const [showForgetPassword, setShowForgetPassword] = useState(false);
//     const [isForgot, setIsForgot] = useState(false);
//     const [loginObj, setLoginObj] = useState({ userName: "", password: "" });
//     const [showPassword, setShowPassword] = useState(false);
//     const [hidePassword, setHidePassword] = useState(true);
//     const [isLoading, setIsLoading] = useState(false);
//     const [error, setError] = useState("");
//     const navigate = useNavigate();
//     const [showPasswordFields, setShowPasswordFields] = useState(false);
//     const [forgotEmail, setForgotEmail] = useState("");
//     const [email, setEmail] = useState("");
//     const [message, setMessage] = useState("");
//     const [isSignup, setIsSignup] = useState(false);
//     const [isEmailSubmitted, setIsEmailSubmitted] = useState(false);
//     const [loginStepStarted, setLoginStepStarted] = useState(false);
//     const [emailCheckMessage, setEmailCheckMessage] = useState("");
//     const [loading, setLoading] = useState(false);
//     const [cartCount, setCartCount] = useState(0);
//     const [signupType, setSignupType] = useState("personal");
//     const [termsAccepted, setTermsAccepted] = useState(false);
//     const [showContainer, setShowContainer] = useState(false);
//     const [drawerOpen, setDrawerOpen] = useState(false);
//     const [isLoginOpen, setIsLoginOpen] = useState(false);
//     const GOOGLE_API_KEY = "";
//     const [userLocation, setUserLocation] = useState("");
//     const [isLoggedIn, setIsLoggedIn] = useState(false);
//     const [isVerifying, setIsVerifying] = useState(false);

//     const [savedAddresses, setSavedAddresses] = useState(() => {
//         const data = localStorage.getItem("savedAddresses");
//         return data ? JSON.parse(data) : [];
//     });

//     const { vendorId } = useParams();

//     const [showLocationPopup, setShowLocationPopup] = useState(false);
//     const [selectedAddress, setSelectedAddress] = useState(null);
//     const [searchQuery, setSearchQuery] = useState("");
//     const [isLocating, setIsLocating] = useState(false);
//     const [locationError, setLocationError] = useState("");
//     const [showMapPopup, setShowMapPopup] = useState(false);
//     const [mapSelectedLocation, setMapSelectedLocation] = useState(null);
//     const [mapAddress, setMapAddress] = useState("");
//     const [addressTitle, setAddressTitle] = useState("");
//     const [isMapLoading, setIsMapLoading] = useState(false);
//     const [showMobileSearch, setShowMobileSearch] = useState(false);
//     const [showOtpPopup, setShowOtpPopup] = useState(false);
//           const [otp, setOtp] = useState("");
//     const mapRef = useRef(null);

//     const openLoginDrawer = () => setIsLoginOpen(true);
//     const closeLoginDrawer = () => setIsLoginOpen(false);

//     const userId = localStorage.getItem("userId");

//     // ✅ FIXED: Use consistent key getter
//     const { SAVED_KEY, CURRENT_KEY, SELECTED_KEY } = getStorageKeys(userId);

//     // ✅ FIXED: Helper to dispatch location events so ReelsSection refreshes
//     // Add this near line 70, after your getStorageKeys function
// const dispatchLocationUpdated = () => {
//     // Dispatch storage event for same-tab listeners
//     window.dispatchEvent(new Event("storage"));
//     // Dispatch custom event for ReelsSection
//     window.dispatchEvent(new CustomEvent("locationUpdated"));
//     ////console.log("📡 locationUpdated event dispatched from Cloudnavbar");
// };

//     useEffect(() => {
//         if (isSignup) {
//             setIsSignup(true);
//             setShowLogin(true);
//         }
//     }, [isSignup]);

//     useEffect(() => {
//         let timeoutId;
//         if (showContainer) {
//             timeoutId = setTimeout(() => setShowContainer(false), 4000);
//         }
//         return () => { if (timeoutId) clearTimeout(timeoutId); };
//     }, [showContainer]);

//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             const profileIcon = document.querySelector('[data-profile-icon]');
//             const dropdown = document.querySelector('[data-profile-dropdown]');
//             if (
//                 showContainer &&
//                 profileIcon &&
//                 dropdown &&
//                 !profileIcon.contains(event.target) &&
//                 !dropdown.contains(event.target)
//             ) {
//                 setShowContainer(false);
//             }
//         };
//         document.addEventListener('mousedown', handleClickOutside);
//         return () => document.removeEventListener('mousedown', handleClickOutside);
//     }, [showContainer]);

//     function handleSignInClick() { setShowLogin(true); }

//     const handleProfile = () => navigate("/profilepage");

//     const handleLogout = () => {
//         localStorage.removeItem("isLoggedIn");
//         localStorage.removeItem("authToken");
//         localStorage.removeItem("vendorId");
//         setIsLoggedIn(false);
//         setShowContainer(false);
//     };

//     useEffect(() => {
//         const token = localStorage.getItem("userToken");
//         if (token) setIsLoggedIn(true);
//     }, []);

//     useEffect(() => {
//         const handleResize = () => {
//             setIsMobile(window.innerWidth <= 768);
//             if (window.innerWidth > 768) setShowMobileMenu(false);
//         };
//         const handleScroll = () => setScrolled(window.scrollY > 50);
//         window.addEventListener("resize", handleResize);
//         window.addEventListener("scroll", handleScroll);
//         return () => {
//             window.removeEventListener("resize", handleResize);
//             window.removeEventListener("scroll", handleScroll);
//         };
//     }, []);

//     const handleChange = (e) => setLoginObj({ ...loginObj, [e.target.name]: e.target.value });

//     const handleSignup = async (e) => {
//         e.preventDefault();
//         setError("");
//         if (!termsAccepted) { setError("Please select Terms and Conditions"); return; }
//         if (!loginObj.userName || !loginObj.emailId || !loginObj.password) {
//             setError("Please fill all required fields"); return;
//         }
//         setIsLoading(true);
//         const requestBody = {
//             userName: loginObj.userName,
//             emailId: loginObj.emailId,
//             password: loginObj.password,
//             referralCodeUsed: loginObj.referralCodeUsed || null,
//             mobileNumber: loginObj.mobileNumber,
//             companyName: loginObj.companyName || null,
//             role: "ROLE_USER",
//             userType: signupType === "personal" ? "PERSONAL" : "PROFESSIONAL",
//             termsAndConditions: termsAccepted,
//         };
//         try {
//             const response = await fetch(
//                 "https://backend.maamaas.com/subscription/api/user/registration",
//                 { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(requestBody) }
//             );
//             let result;
//             try { result = JSON.parse(await response.text()); } catch { result = {}; }
//             if (response.ok) {
//     alert("Signup successful! Please verify OTP");

//     setShowOtpPopup(true);   // ✅ popup open
// } else {
//                 setError(result.message || "Signup failed");
//             }
//         } catch (error) {
//             // console.error("❌ Signup error:", error);
//             setError("Something went wrong. Please try again.");
//         }
//         setIsLoading(false);
//     };

// const handleVerifyOtp = async () => {
//     if (!otp) {
//         setError("Please enter OTP");
//         return;
//     }
//  setIsVerifying(true); 
//     try {
//         const response = await fetch(
//             `https://backend.maamaas.com/subscription/api/user/registration/verifyotp?mobile=${loginObj.mobileNumber}&otp=${otp}`,
//             { method: "POST" }
//         );

//         // ✅ Always use text first
//         const text = await response.text();

//         let result;
//         try {
//             result = JSON.parse(text);
//         } catch {
//             result = { message: text };  // plain text handle
//         }

//         if (response.ok) {
//             alert("✅ OTP Verified Successfully!");
//             setShowOtpPopup(false);
//             setIsSignup(false);
//         } else {
//             setError(result.message || text);
//         }

//     } catch (err) {
//         // console.error(err);
//         setError("Something went wrong");
//     }
//      setIsVerifying(false);
// };

// const handleResendOtp = async () => {
//     try {
//         await fetch(
//             `https://backend.maamaas.com/subscription/api/user/resendotp?mobile=${loginObj.mobileNumber}`,
//             { method: "POST" }
//         );
//         alert("OTP Sent Again");
//     } catch {
//         setError("Failed to resend OTP");
//     }
// };
//     const handleChanges = (e) => {
//         const { name, value } = e.target;
//         setLoginObj((prev) => ({ ...prev, [name]: value }));
//     };

//     const handleLogin = async (e) => {
//         e.preventDefault();
//         setIsLoading(true);
//         setError("");
//         try {
//             const url = `https://backend.maamaas.com/subscription/api/auth/login/user?identifier=${encodeURIComponent(loginObj.identifier)}&password=${encodeURIComponent(loginObj.password)}`;
//             const response = await fetch(url, { method: "POST", headers: { accept: "*/*" } });
//             const text = await response.text();
//             let data;
//             try { data = JSON.parse(text); } catch { throw new Error("Invalid JSON response from server"); }
//             //console.log("🔹 Login API Response:", data);
//             if (response.ok && data.token) {
//                 localStorage.setItem("authToken", data.token);
//                 localStorage.setItem("refreshToken", data.refreshToken);
//                 localStorage.setItem("userId", data.userId);
//                 localStorage.setItem("userType", data.userType || "");
//                 localStorage.setItem("role", data.role);
//                 localStorage.setItem("isLoggedIn", "true");
//                 localStorage.setItem("customerId", "usrUSR140520263");

//                 if (data.professionalUserId) {
//                     localStorage.setItem("professionalUserId", data.professionalUserId);
//                 } else {
//                     localStorage.removeItem("professionalUserId");
//                 }

//                 alert("Login successful!");
//                 setIsLoggedIn(true);
//                 setShowLogin(false);

//                 window.dispatchEvent(new Event('storage'));
//                 window.dispatchEvent(new CustomEvent('loginStatusChanged', { detail: { isLoggedIn: true } }));

//                 if (data.professionalUserId) {
//                     navigate("/professional-registration");
//                 } else {
//                     const redirectTo = localStorage.getItem("redirectAfterLogin") || "/user-dashboard";
//                     navigate(redirectTo);
//                 }
//             } else {
//                 setError(data.message || "Invalid credentials.");
//             }
//         } catch (error) {
//             // console.error("❌ Login error:", error);
//             setError("Email or Password wrong. Please try again later.");
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     useEffect(() => {
//         const checkLogin = () => {
//             setIsLoggedIn(localStorage.getItem("isLoggedIn") === "true");
//         };
//         checkLogin();
//         window.addEventListener("storage", checkLogin);
//         return () => window.removeEventListener("storage", checkLogin);
//     }, []);


//     const togglePopup = () => setShowPopup(!showPopup);
//     const toggleMobileMenu = () => setShowMobileMenu(!showMobileMenu);
//     const toggleMobileSearch = () => {
//         setShowMobileSearch(!showMobileSearch);
//         setShowMobileMenu(false);
//     };

//     useEffect(() => { fetchUserSavedLocation(); }, []);

//     // Add near other useEffects (around line 210)
// useEffect(() => {
//     const handleOpenLocationPopup = () => {
//         //console.log("📍 Opening location popup from ReelsSection");
//         setShowLocationPopup(true);
//     };

//     window.addEventListener("openLocationPopup", handleOpenLocationPopup);

//     return () => {
//         window.removeEventListener("openLocationPopup", handleOpenLocationPopup);
//     };
// }, []);

//     // ✅ FIXED: Save addresses to localStorage and dispatch event
//     useEffect(() => {
//         if (!userId) return;
//         localStorage.setItem(SAVED_KEY, JSON.stringify(savedAddresses));
//     }, [savedAddresses, userId]);

//     // ✅ FIXED: Save selected address as JSON object (so ReelsSection can parse it)
//     useEffect(() => {
//         if (!userId || !selectedAddress) return;
//         // Store as plain string (ReelsSection handles both)
//         localStorage.setItem(SELECTED_KEY, JSON.stringify(selectedAddress));
//     }, [selectedAddress, userId]);

//     // ✅ FIXED: Load saved data on mount
//     useEffect(() => {
//         if (!userId) return;
//         const saved = localStorage.getItem(SAVED_KEY);
//         const current = localStorage.getItem(CURRENT_KEY);
//         if (saved) {
//             try { setSavedAddresses(JSON.parse(saved)); } catch {}
//         }
//         if (current) {
//             try {
//                 const c = JSON.parse(current);
//                 setSelectedAddress(c.full);
//                 setUserLocation({ lat: c.lat, lng: c.lng });
//             } catch {}
//         }
//     }, [userId]);

//     // Map init
//     useEffect(() => {
//         if (!showMapPopup) return;
//         const loadLeaflet = () => {
//             if (!window.L) {
//                 const script = document.createElement("script");
//                 script.src = "https://unpkg.com/leaflet@1.7.1/dist/leaflet.js";
//                 script.onload = initializeMap;
//                 document.body.appendChild(script);
//             } else {
//                 initializeMap();
//             }
//         };
//         if (!document.querySelector('link[href*="leaflet"]')) {
//             const link = document.createElement("link");
//             link.rel = "stylesheet";
//             link.href = "https://unpkg.com/leaflet@1.7.1/dist/leaflet.css";
//             document.head.appendChild(link);
//         }
//         loadLeaflet();
//         return () => {
//             if (window.currentMap) { window.currentMap.remove(); window.currentMap = null; }
//         };
//     }, [showMapPopup]);

//     const initializeMap = () => {
//         if (!mapRef.current || !window.L) return;
//         if (window.currentMap) window.currentMap.remove();
//         const defaultLocation = [40.7128, -74.0060];
//         const map = window.L.map(mapRef.current).setView(defaultLocation, 13);
//         window.currentMap = map;
//         window.L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
//             attribution: "© OpenStreetMap contributors",
//         }).addTo(map);
//         map.on("click", (e) => {
//             const loc = [e.latlng.lat, e.latlng.lng];
//             setMapSelectedLocation(loc);
//             updateMarker(loc, map);
//             getAddressFromCoordinates(loc);
//         });
//         if (navigator.geolocation) {
//             navigator.geolocation.getCurrentPosition(
//                 (pos) => {
//                     const loc = [pos.coords.latitude, pos.coords.longitude];
//                     map.setView(loc, 15);
//                     setMapSelectedLocation(loc);
//                     updateMarker(loc, map);
//                     getAddressFromCoordinates(loc);
//                 },
//                 () => {
//                     setMapSelectedLocation(defaultLocation);
//                     updateMarker(defaultLocation, map);
//                     getAddressFromCoordinates(defaultLocation);
//                 }
//             );
//         }
//     };

//     const updateMarker = (location, map) => {
//         if (window.currentMarker) window.currentMarker.remove();
//         const marker = window.L.marker(location, { draggable: true }).addTo(map);
//         window.currentMarker = marker;
//         marker.on("dragend", (e) => {
//             const loc = [e.target.getLatLng().lat, e.target.getLatLng().lng];
//             setMapSelectedLocation(loc);
//             getAddressFromCoordinates(loc);
//         });
//     };

//     const getAddressFromCoordinates = async (location) => {
//         setIsMapLoading(true);
//         try {
//             const res = await fetch(
//                 `https://maps.googleapis.com/maps/api/geocode/json?latlng=${location[0]},${location[1]}&key=${GOOGLE_API_KEY}`
//             );
//             const data = await res.json();
//             if (data.status === "OK" && data.results.length > 0) {
//                 setMapAddress(data.results[0].formatted_address);
//             } else {
//                 setMapAddress("Address not found");
//             }
//         } catch (err) {
//             setMapAddress("Error getting address");
//         } finally {
//             setIsMapLoading(false);
//         }
//     };

//     // ✅ FIXED: handleSaveAddressFromMap — correct API URL + dispatch event
//     const handleSaveAddressFromMap = async () => {
//     if (!mapSelectedLocation || !mapAddress) return;

//     const newAddress = {
//         title: addressTitle || "Custom Location",
//         full: mapAddress,
//         lat: mapSelectedLocation[0],
//         lng: mapSelectedLocation[1],
//     };

//     const currentUserId = localStorage.getItem("userId");
//     const { CURRENT_KEY: CK, SELECTED_KEY: SK, SAVED_KEY: SAK } = getStorageKeys(currentUserId);

//     // Save to localStorage
//     localStorage.setItem(CK, JSON.stringify(newAddress));
//     localStorage.setItem(SK, JSON.stringify(newAddress.full));

//     setSavedAddresses(prev => [newAddress, ...prev]);
//     setSelectedAddress(newAddress.full);
//     setUserLocation({ lat: newAddress.lat, lng: newAddress.lng });

//     // ✅ Notify ReelsSection
//     dispatchLocationUpdated();

//     // ✅ Save to backend
//     const token = localStorage.getItem("authToken");
//     const customerId = localStorage.getItem("customerId") || "usrUSR140520263";
//     localStorage.setItem("customerId", customerId);

//     if (token && currentUserId) {
//         try {
//             const requestBody = {
//                 userId: parseInt(currentUserId),
//                 customerId: customerId,
//                 latitude: newAddress.lat,
//                 longitude: newAddress.lng,
//                 address: newAddress.full,
//                 city: "",
//                 category: addressTitle || "home",
//             };

//             //console.log("📍 Saving location to backend:", requestBody);

//             const response = await fetch(
//                 "https://backend.maamaas.com/subscription/api/user/current/location/update",
//                 {
//                     method: "POST",
//                     headers: {
//                         "Content-Type": "application/json",
//                         Authorization: `Bearer ${token}`,
//                     },
//                     body: JSON.stringify(requestBody),
//                 }
//             );

//             if (response.ok) {
//                 //console.log("✅ Location saved to backend successfully");
//             } else {
//                 const errorText = await response.text();
//                 console.warn("⚠️ Backend location save failed:", response.status, errorText);
//             }
//         } catch (error) {
//             // console.error("❌ Error saving location to backend:", error);
//         }
//     }

//     setShowMapPopup(false);
//     setShowLocationPopup(false);
// };

//     // ✅ FIXED: getCurrentLocation — correct keys + dispatch event
//    const getCurrentLocation = () => {
//     if (!navigator.geolocation) {
//         setLocationError("Geolocation not supported");
//         return;
//     }

//     setIsLocating(true);
//     setLocationError("");

//     navigator.geolocation.getCurrentPosition(
//         async (pos) => {
//             const latitude = pos.coords.latitude;
//             const longitude = pos.coords.longitude;

//             if (latitude == null || longitude == null) {
//                 setLocationError("Unable to fetch coordinates");
//                 setIsLocating(false);
//                 return;
//             }

//             let fullAddress = `Lat: ${latitude}, Lng: ${longitude}`;
//             try {
//                 if (GOOGLE_API_KEY) {
//                     const res = await fetch(
//                         `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGLE_API_KEY}`
//                     );
//                     const data = await res.json();
//                     fullAddress = data?.results?.[0]?.formatted_address || fullAddress;
//                 }
//             } catch (err) {
//                 // console.error("Geocode error:", err);
//             }

//             const currentLocation = {
//                 title: "Current Location",
//                 full: fullAddress,
//                 lat: latitude,
//                 lng: longitude,
//             };

//             const currentUserId = localStorage.getItem("userId");
//             const { CURRENT_KEY: CK, SELECTED_KEY: SK, SAVED_KEY: SAK } = getStorageKeys(currentUserId);

//             // Save to localStorage
//             localStorage.setItem(CK, JSON.stringify(currentLocation));
//             localStorage.setItem(SK, JSON.stringify(fullAddress));

//             setSelectedAddress(fullAddress);
//             setUserLocation({ lat: latitude, lng: longitude });

//             setSavedAddresses(prev => {
//                 const exists = prev.some(a => a.title === "Current Location");
//                 const updated = exists 
//                     ? prev.map(a => a.title === "Current Location" ? currentLocation : a)
//                     : [currentLocation, ...prev];
//                 localStorage.setItem(SAK, JSON.stringify(updated));
//                 return updated;
//             });

//             // ✅ Save to backend
//             const token = localStorage.getItem("authToken");
//             const customerId = localStorage.getItem("customerId") || "usrUSR140520263";

//             if (token && currentUserId) {
//                 try {
//                     const requestBody = {
//                         userId: parseInt(currentUserId),
//                         customerId: customerId,
//                         latitude: latitude,
//                         longitude: longitude,
//                         address: fullAddress,
//                         city: "",
//                         category: "current_location",
//                     };

//                     await fetch(
//                         "https://backend.maamaas.com/subscription/api/user/current/location/update",
//                         {
//                             method: "POST",
//                             headers: {
//                                 "Content-Type": "application/json",
//                                 Authorization: `Bearer ${token}`,
//                             },
//                             body: JSON.stringify(requestBody),
//                         }
//                     );
//                 } catch (err) {
//                     // console.error("Error saving location to backend:", err);
//                 }
//             }

//             // ✅ Notify ReelsSection
//             dispatchLocationUpdated();

//             setIsLocating(false);
//             setShowLocationPopup(false);
//         },
//         (error) => {
//             // console.error("Geolocation error:", error);
//             let msg = "Location access denied";
//             if (error.code === 2) msg = "Location unavailable";
//             if (error.code === 3) msg = "Location request timeout";
//             setLocationError(msg);
//             setIsLocating(false);
//         },
//         { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
//     );
// };

//     // Add this function after your other functions (around line 300)
// const fetchUserSavedLocation = async () => {
//     const token = localStorage.getItem("authToken");
//     const currentUserId = localStorage.getItem("userId");

//     if (!token || !currentUserId) {
//         //console.log("No token or userId found for fetching saved location");
//         return;
//     }

//     try {
//         //console.log("🔄 Fetching saved location for userId:", currentUserId);
//         const response = await fetch(
//             `https://backend.maamaas.com/subscription/api/user/get/current/location/${currentUserId}`,
//             { 
//                 method: "GET",
//                 headers: { 
//                     Authorization: `Bearer ${token}`,
//                     "Content-Type": "application/json"
//                 } 
//             }
//         );

//         if (!response.ok) {
//             // console.warn("fetchUserSavedLocation failed:", response.status);
//             return;
//         }

//         const text = await response.text();
//         if (!text || text.trim() === "") {
//             //console.log("No saved location found");
//             return;
//         }

//         const data = JSON.parse(text);
//         //console.log("✅ Retrieved saved location:", data);

//         if (data && data.address) {
//             const locationObj = {
//                 title: "Saved Location",
//                 full: data.address,
//                 lat: data.latitude || data.lat || 0,
//                 lng: data.longitude || data.lng || 0,
//             };

//             const { CURRENT_KEY: CK, SELECTED_KEY: SK } = getStorageKeys(currentUserId);
//             localStorage.setItem(CK, JSON.stringify(locationObj));
//             localStorage.setItem(SK, JSON.stringify(data.address));

//             setSelectedAddress(data.address);
//             setUserLocation({ lat: locationObj.lat, lng: locationObj.lng });

//             if (data.customerId) {
//                 localStorage.setItem("customerId", data.customerId);
//             }

//             // Notify ReelsSection that location is ready
//             dispatchLocationUpdated();
//         }
//     } catch (err) {
//         // console.error("fetchUserSavedLocation error:", err);
//     }
// };

//     const handleAddressSearch = async () => {
//         if (!searchQuery.trim()) return;
//         try {
//             const response = await fetch(
//                 `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchQuery)}&limit=5`
//             );
//             const data = await response.json();
//             if (data && data.length > 0) {
//                 const result = data[0];
//                 const address = result.display_name;
//                 const currentUserId = localStorage.getItem("userId");
//                 const locationObj = {
//                     title: "Searched Location",
//                     full: address,
//                     lat: parseFloat(result.lat),
//                     lng: parseFloat(result.lon),
//                 };

//                 const { CURRENT_KEY: CK, SELECTED_KEY: SK } = getStorageKeys(currentUserId);
//                 localStorage.setItem(CK, JSON.stringify(locationObj));
//                 localStorage.setItem(SK, JSON.stringify(address));

//                 setSelectedAddress(address);

//                 setSavedAddresses((prev) => {
//                     const updated = [locationObj, ...prev];
//                     const { SAVED_KEY: SAK } = getStorageKeys(currentUserId);
//                     localStorage.setItem(SAK, JSON.stringify(updated));
//                     return updated;
//                 });

//                 // ✅ Notify ReelsSection
//                 dispatchLocationUpdated();

//                 setShowLocationPopup(false);
//                 setSearchQuery("");
//             } else {
//                 setLocationError("No addresses found for your search.");
//             }
//         } catch (error) {
//             // console.error("Error searching address:", error);
//             setLocationError("Error searching for address. Please try again.");
//         }
//     };

//     useEffect(() => {
//         const handleScroll = () => setScrolled(window.scrollY > 50);
//         const handleResize = () => setIsMobile(window.innerWidth < 768);
//         window.addEventListener("scroll", handleScroll);
//         window.addEventListener("resize", handleResize);
//         return () => {
//             window.removeEventListener("scroll", handleScroll);
//             window.removeEventListener("resize", handleResize);
//         };
//     }, []);

//     const handleEmailChange = (e) => setEmail(e.target.value);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
//         setMessage("");
//         if (!email) { setMessage("Please enter your email."); setLoading(false); return; }
//         try {
//             const response = await axios.post(
//                 "https://backend.maamaas.com/subscription/api/user/forget/password",
//                 { identifier: email }
//             );
//             if (response.status === 200) {
//                 setMessage("Reset link sent successfully to your email.");
//                 setIsEmailSubmitted(true);
//             } else {
//                 setMessage("Something went wrong. Please try again.");
//             }
//         } catch (error) {
//             setMessage(error.response?.data?.message || "Error while sending reset link. Please try again.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     // =====================
//     // STYLES (unchanged from original)
//     // =====================
//     const styles = {
//         nav: {
//             position: "fixed", top: 0, left: 0, width: "100%", zIndex: 100,
//             padding: isMobile ? "10px 16px" : "16px 32px",
//             display: "flex", justifyContent: "space-between", alignItems: "center",
//             backgroundColor: scrolled ? "#ee6521" : "white", color: "#ee6521",
//             backdropFilter: scrolled ? "blur(8px)" : "none",
//             boxShadow: scrolled ? "0 2px 10px rgba(0,0,0,0.1)" : "none",
//             transition: "all 0.4s ease", height: "65px",
//         },
//         logo: { display: "flex", alignItems: "center", fontSize: isMobile ? "20px" : "26px", fontWeight: "bold", color: "white", zIndex: 101 },
//         navRight: {
//             display: isMobile ? (showMobileMenu ? "flex" : "none") : "flex",
//             flexDirection: "row", alignItems: "center", justifyContent: "space-evenly",
//             gap: isMobile ? "15px" : "20px",
//             position: isMobile ? "fixed" : "relative",
//             top: isMobile ? "65px" : "auto", left: 0, right: 0,
//             backgroundColor: isMobile ? "#fff" : "transparent",
//             padding: isMobile ? "10px" : "0",
//             width: isMobile ? "100%" : "auto",
//             boxShadow: isMobile ? "0 5px 10px rgba(0,0,0,0.1)" : "none",
//             zIndex: 100, borderRadius: "10px",
//         },
//         link: {
//             textDecoration: "none", color: isMobile ? "#000" : "#ee6521",
//             fontSize: isMobile ? "17px" : "14px", fontWeight: "bold", cursor: "pointer",
//             whiteSpace: "nowrap", padding: isMobile ? "8px 0" : "0", textTransform: "uppercase",
//         },
//         navLinks: { display: "flex", flexDirection: "row", alignItems: "center", gap: isMobile ? "5px" : "20px", marginRight: isMobile ? "0" : "20px" },
//         signInBtn: {
//             padding: isMobile ? "8px 16px" : "10px 20px", backgroundColor: "orange",
//             border: "none", borderRadius: "15px", color: "#ee6521", fontWeight: "600",
//             cursor: "pointer", fontSize: isMobile ? "14px" : "16px", whiteSpace: "nowrap", textTransform: "uppercase",
//         },
//         loginForm: {
//             position: "fixed", top: isMobile ? "10px" : "20px",
//             right: showLogin ? "0" : "-100%",
//             width: "100%", maxWidth: isMobile ? "90%" : "400px",
//             backgroundColor: "white", borderRadius: "20px",
//             padding: isMobile ? "20px 15px" : "40px 30px",
//             boxShadow: "-5px 0 15px rgba(0, 0, 0, 0.1)",
//             transition: "right 0.5s ease-in-out", zIndex: 999,
//             display: "flex", flexDirection: "column", gap: "20px", overflowY: "auto", scrollbarWidth:"none",
//         },
//         locationWrapper: {
//             display: isMobile ? "none" : "flex", alignItems: "center", gap: "12px",
//             flex: 1, maxWidth: "650px", margin: "0 20px",
//         },
//         locationBox: {
//             display: "flex", alignItems: "center", gap: "12px",
//             padding: "5px 18px", backgroundColor: "#ee6521",
//             borderRadius: "25px", cursor: "pointer", transition: "all 0.3s ease",
//             minWidth: "280px", border: "1px solid rgba(255,255,255,0.4)",
//             flexShrink: 0, fontSize: "16px", fontWeight: "600",
//         },
//         locationIcon: { color: "#FFD700", fontSize: "20px", flexShrink: 0 },
//         locationText: {
//             fontSize: "16px", fontWeight: "600", color: "white",
//             whiteSpace: "nowrap", overflow: "auto", textOverflow: "ellipsis",scrollbarWidth:"none",
//             maxWidth: "180px", flex: 1,
//         },
//         downArrow: { color: "white", fontSize: "16px", marginLeft: "4px", flexShrink: 0 },
//         mobileLocationWrapper: {
//             display: isMobile ? "flex" : "none", alignItems: "center",
//             gap: "10px", marginLeft: "auto", marginRight: "15px",
//         },
//         mobileLocationIcon: {
//             display: "flex", alignItems: "center", justifyContent: "center",
//             padding: "10px", borderRadius: "50%", cursor: "pointer",
//             transition: "all 0.3s ease", minWidth: "44px", minHeight: "44px",
//         },
//         locationPopupOverlay: {
//             position: "fixed", top: 59, left: 0, width: "100%",
//             display: "flex", justifyContent: "center", alignItems: "center",
//             zIndex: 1000, padding: isMobile ? "10px" : "20px", boxSizing: "border-box",
//         },
//         locationPopup: {
//             width: "100%", maxWidth: "500px", maxHeight: "80vh",
//             backgroundColor: "white", borderRadius: "12px", padding: "20px",
//             boxShadow: "0 10px 25px rgba(0,0,0,0.2)", overflowY: "auto", position: "relative", scrollbarWidth:"none",
//         },
//         popupHeader: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", paddingBottom: "15px", borderBottom: "1px solid #eee" },
//         popupTitle: { margin: 0, fontSize: "20px", fontWeight: "600", color: "#333" },
//         closePopupBtn: { background: "transparent", border: "none", fontSize: "20px", cursor: "pointer", color: "#666", padding: "5px" },
//         optionBox: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "15px", backgroundColor: "#f8f9fa", borderRadius: "8px", marginBottom: "15px", cursor: "pointer", transition: "all 0.3s ease", border: "1px solid #e9ecef" },
//         optionContent: { display: "flex", alignItems: "center", gap: "12px" },
//         optionTitle: { margin: 0, fontSize: "16px", fontWeight: "600", color: "#333" },
//         optionDesc: { margin: "4px 0 0 0", fontSize: "13px", color: "#666" },
//         enableBtn: { padding: "8px 16px", backgroundColor: "#9d36ca", color: "white", border: "none", borderRadius: "6px", fontSize: "13px", fontWeight: "500", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px" },
//         addAddressBox: { display: "flex", alignItems: "center", gap: "12px", padding: "15px", backgroundColor: "#f0f8ff", borderRadius: "8px", marginBottom: "20px", cursor: "pointer", transition: "all 0.3s ease", border: "1px dashed #a54dd4" },
//         plusIcon: { fontSize: "18px", color: "#a551d9", fontWeight: "bold" },
//         addAddressText: { fontSize: "16px", fontWeight: "500", color: "#983fc1" },
//         errorMessage: { padding: "10px 15px", backgroundColor: "#ffe6e6", color: "#d63031", borderRadius: "6px", marginBottom: "15px", fontSize: "14px" },
//         savedHeading: { fontSize: "16px", fontWeight: "600", color: "#333", marginBottom: "12px" },
//         savedBox: { display: "flex", alignItems: "flex-start", gap: "12px", padding: "15px", backgroundColor: "#fff", borderRadius: "8px", marginBottom: "10px", cursor: "pointer", transition: "all 0.3s ease", border: "1px solid #eee" },
//         savedLeft: { display: "flex", alignItems: "center", gap: "8px" },
//         pinIcon: { color: "#d63031", fontSize: "16px" },
//         savedTitle: { margin: 0, fontSize: "15px", fontWeight: "600", color: "#333" },
//         savedAddressText: { margin: "4px 0 0 0", fontSize: "13px", color: "#666", lineHeight: "1.4" },
//         loadingSpinner: { display: "inline-block", width: "12px", height: "12px", border: "2px solid transparent", borderTop: "2px solid currentColor", borderRadius: "50%", animation: "spin 1s linear infinite" },
//     };

//     return (
//         <>
//             <nav style={styles.nav}>
//                 <div style={styles.logo}>
//                     <Link to="/" style={{ ...styles.logo, textDecoration: "none" }}>
//                         <div style={{ fontSize: window.innerWidth <= 600 ? "20px" : "25px", fontWeight: "bold", fontFamily: "'Poppins', sans-serif" }}>
//                             <span style={{ color: "black" }}>MAA</span>
//                             <span style={{ color: "#ee6521" }}>MAAS</span>
//                         </div>
//                     </Link>
//                 </div>

//                 {/* Desktop Location */}
//                 <div style={styles.locationWrapper}>
//                     <div
//                         style={styles.locationBox}
//                         onClick={() => setShowLocationPopup(true)}
//                         onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0,0,0,0.2)"; e.currentTarget.style.backgroundColor = "#ee6521"; }}
//                         onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.backgroundColor = "#ee6521"; }}
//                     >
//                         <span style={styles.locationIcon}><FaMapMarkerAlt /></span>
//                         <span style={styles.locationText}>
//                             {selectedAddress
//                                 ? (selectedAddress.length > 25 ? selectedAddress.substring(0, 25) + "..." : selectedAddress)
//                                 : "Select Location"}
//                         </span>
//                         <span style={styles.downArrow}>▾</span>
//                     </div>
//                 </div>

//                 {/* Mobile Location Icon */}
//                 <div style={styles.mobileLocationWrapper}>
//                     <div style={styles.mobileLocationIcon} onClick={() => setShowLocationPopup(true)}>
//                         <span style={styles.locationIcon}><FaMapMarkerAlt /></span>
//                     </div>
//                 </div>

//                 {/* Location Popup */}
//                 {showLocationPopup && (
//                     <div style={styles.locationPopupOverlay}>
//                         <div style={styles.locationPopup}>
//                             <div style={styles.popupHeader}>
//                                 <h2 style={styles.popupTitle}>Select Your Location</h2>
//                                 <button style={styles.closePopupBtn} onClick={() => { setShowLocationPopup(false); setLocationError(""); setSearchQuery(""); }}>✕</button>
//                             </div>

//                             <div style={styles.optionBox} onClick={getCurrentLocation}>
//                                 <div style={styles.optionContent}>
//                                     <span style={{ color: "#FF4D4D", fontSize: "18px" }}><FaMapMarkerAlt /></span>
//                                     <div>
//                                         <h3 style={styles.optionTitle}>Use My Current Location</h3>
//                                         <p style={styles.optionDesc}>Enable your current location for better services</p>
//                                     </div>
//                                 </div>
//                                 <button style={styles.enableBtn} disabled={isLocating}>
//                                     {isLocating ? <><span style={styles.loadingSpinner}></span> Locating...</> : "Detect"}
//                                 </button>
//                             </div>

//                             <div style={styles.addAddressBox} onClick={() => setShowMapPopup(true)}>
//                                 <span style={styles.plusIcon}>＋</span>
//                                 <span style={styles.addAddressText}>Add New Address on Map</span>
//                             </div>

//                             {locationError && <div style={styles.errorMessage}>{locationError}</div>}

//                             <h3 style={styles.savedHeading}>Saved Addresses</h3>
//                             {savedAddresses.map((item, index) => (
//                                 <div
//                                     key={index}
//                                     style={styles.savedBox}
//                                     onClick={() => {
//                                         const currentUserId = localStorage.getItem("userId");
//                                         const { CURRENT_KEY: CK, SELECTED_KEY: SK } = getStorageKeys(currentUserId);
//                                         localStorage.setItem(CK, JSON.stringify(item));
//                                         localStorage.setItem(SK, JSON.stringify(item.full));
//                                         setSelectedAddress(item.full);
//                                         setUserLocation({ lat: item.lat, lng: item.lng });
//                                         // ✅ Notify ReelsSection
//                                         dispatchLocationUpdated();
//                                         setShowLocationPopup(false);
//                                         setLocationError("");
//                                     }}
//                                 >
//                                     <div style={styles.savedLeft}>
//                                         <span style={styles.pinIcon}><FaMapMarkerAlt /></span>
//                                     </div>
//                                     <div>
//                                         <h4 style={styles.savedTitle}>{item.title}</h4>
//                                         <p style={styles.savedAddressText}>{item.full}</p>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 )}

//                 {/* Map Popup */}
//                 {showMapPopup && (
//                     <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, padding: "20px", boxSizing: "border-box" }}>
//                         <div style={{ width: "100%", maxWidth: "700px", height: "100vh", background: "#fff", borderRadius: "12px", display: "flex", flexDirection: "column", overflow: "auto", boxShadow: "0 10px 25px rgba(0,0,0,0.25)" }}>
//                             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", borderBottom: "1px solid #ddd" }}>
//                                 <h2 style={{ margin: 0, fontSize: "18px", fontWeight: 600 }}>Select Location on Map</h2>
//                                 <button style={{ background: "transparent", border: "none", fontSize: "20px", cursor: "pointer" }}
//                                     onClick={() => { setShowMapPopup(false); setMapSelectedLocation(null); setMapAddress(""); setAddressTitle(""); if (window.currentMap) { window.currentMap.remove(); window.currentMap = null; } }}>✕</button>
//                             </div>
//                             <div style={{ flex: 1, position: "relative", display: "flex", flexDirection: "column" }}>
//                                 <div ref={mapRef} style={{ flex: 1, width: "100%", minHeight: "300px", background: "#f0f0f0" }}>
//                                     {!window.L && (
//                                         <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, display: "flex", justifyContent: "center", alignItems: "center", color: "#666" }}>
//                                             Loading map...
//                                         </div>
//                                     )}
//                                 </div>
//                                 <div style={{ padding: "12px 16px", borderTop: "1px solid #ddd", display: "flex", flexDirection: "column", gap: "10px" }}>
//                                     <div style={{ minHeight: "24px", color: "#333", fontSize: "14px" }}>
//                                         {isMapLoading ? "Getting address..." : mapAddress || "Click on the map to select a location"}
//                                     </div>
//                                     <input
//                                         type="text"
//                                         placeholder="Address Title (e.g., Home, Office)"
//                                         style={{ padding: "8px 10px", fontSize: "14px", borderRadius: "6px", border: "1px solid #ccc", width: "100%", boxSizing: "border-box" }}
//                                         value={addressTitle}
//                                         onChange={(e) => setAddressTitle(e.target.value)}
//                                     />
//                                     <button
//                                         style={{ padding: "10px 0", fontSize: "16px", borderRadius: "6px", border: "none", background: mapSelectedLocation && mapAddress ? "#ff0054" : "#ccc", color: "#fff", cursor: mapSelectedLocation && mapAddress ? "pointer" : "not-allowed" }}
//                                         disabled={!mapSelectedLocation || !mapAddress}
//                                         onClick={handleSaveAddressFromMap}
//                                     >
//                                         Save Address
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                         <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
//                     </div>
//                 )}

//                 {/* Mobile Sign In / Profile */}
//                 {isMobile ? (
//                     isLoggedIn ? (
//                         <div style={{ display: "flex", border: "2px solid #ee6521", padding: "6px 16px", borderRadius: "25px", color: "#ee6521", cursor: "pointer", alignItems: "center" }} onClick={() => setShowContainer(!showContainer)}>
//                             <AccountCircleIcon sx={{ fontSize: 22, color: "#ee6521" }} />
//                         </div>
//                     ) : (
//                         <div style={{ display: "flex", border: "2px solid #ee6521", padding: "6px 16px", borderRadius: "25px", cursor: "pointer", fontWeight: "600", color: "#ee6521", alignItems: "center", justifyContent: "center" }} onClick={() => setShowLogin(true)}>
//                             Sign In
//                         </div>
//                     )
//                 ) : null}

//                 <div style={styles.navRight}>
//                     <div style={{ ...styles.navLinks, display: isMobile ? "none" : "flex" }}>
//                         <a href="https://partners.maamaas.com/" target="_blank" rel="noopener noreferrer"
//                             style={{ ...styles.link, border: "2px solid #ee6521", padding: "6px 16px", borderRadius: "25px", fontWeight: "600" }}
//                             onMouseEnter={(e) => { e.target.style.backgroundColor = "white"; e.target.style.color = "#ff6600"; }}
//                             onMouseLeave={(e) => { e.target.style.backgroundColor = "#ee6521"; e.target.style.color = "white"; }}>
//                             PARTNERS
//                         </a>
//                         <a href="https://play.google.com/store/apps/details?id=com.maamaas.app" target="_blank" rel="noopener noreferrer"
//                             style={{ ...styles.link, border: "2px solid #ee6521", padding: "6px 16px", borderRadius: "25px", fontWeight: "600" }}
//                             onMouseEnter={(e) => { e.target.style.backgroundColor = "white"; e.target.style.color = "#ff6600"; }}
//                             onMouseLeave={(e) => { e.target.style.backgroundColor = "#ee6521"; e.target.style.color = "white"; }}>
//                             Download App
//                         </a>
//                     </div>

//                     <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
//                         {isLoggedIn ? (
//                             <div style={{ border: isMobile ? "2px solid black" : "2px solid #ee6521", padding: "6px 16px", borderRadius: "25px", display: "flex", alignItems: "center", cursor: "pointer", color: isMobile ? "black" : "white" }}
//                                 onClick={() => setShowContainer(!showContainer)}>
//                                 <AccountCircleIcon sx={{ fontSize: "22px", color: isMobile ? "black" : "#ee6521" }} />
//                             </div>
//                         ) : (
//                             <SliderComponent setShowLogin={setShowLogin} isMobile={isMobile} isLoggedIn={isLoggedIn} />
//                         )}
//                     </div>
//                 </div>
//             </nav>

//             {/* Login Form */}
//             <div style={styles.loginForm}>
//                 <button style={{ position: "absolute", top: "15px", right: "20px", fontSize: "28px", background: "none", border: "none", color: "#333", cursor: "pointer" }}
//                     onClick={() => { setShowLogin(false); setIsForgot(false); setIsSignup(false); }}>
//                     &times;
//                 </button>
//                 <p style={{ marginBottom: 0, fontFamily: "revert", fontSize: isMobile ? "18px" : "22px", color: "#6f21b4", fontWeight: "bold" }}>
//                     WELCOME TO MAAMAA'S
//                 </p>

//                 {!isSignup && !isForgot && (
//                     <form onSubmit={handleLogin} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
//                         <input type="text" placeholder="Email or Mobile Number" name="identifier" value={loginObj.identifier} onChange={handleChanges}
//                             style={{ padding: "10px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "6px" }} />
//                         <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
//                             <input type={showPassword ? "text" : "password"} placeholder="Password" name="password" value={loginObj.password} onChange={handleChanges}
//                                 style={{ padding: "10px", paddingRight: "40px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "6px", width: "100%", boxSizing: "border-box" }} />
//                             <span onClick={() => setShowPassword(!showPassword)} style={{ position: "absolute", top: "50%", right: "10px", transform: "translateY(-50%)", cursor: "pointer", color: "#888" }}>
//                                 {showPassword ? <FaEyeSlash /> : <FaEye />}
//                             </span>
//                         </div>
//                         <div style={{ textAlign: "right" }}>
//                             <span onClick={() => setIsForgot(true)} style={{ color: "#007bff", fontSize: "14px", cursor: "pointer" }}>Forget Password?</span>
//                         </div>
//                         {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}
//                         <button type="submit" style={{ backgroundColor: "#ee6521", color: "white", fontWeight: "bold", padding: "12px", border: "none", borderRadius: "6px", cursor: "pointer" }} disabled={isLoading}>
//                             {isLoading ? "Logging in..." : "LOGIN"}
//                         </button>
//                     </form>
//                 )}

//                 {isForgot && !isEmailSubmitted && (
//                     <form onSubmit={handleSubmit}>
//                         <input type="email" placeholder="Enter your email" value={email} onChange={handleEmailChange} required
//                             style={{ padding: "10px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "6px", marginBottom: "10px", width: "100%" }} />
//                         <button type="submit" style={{ backgroundColor: "#ee6521", color: "white", fontWeight: "bold", padding: "12px", border: "none", borderRadius: "6px", cursor: "pointer", width: "100%" }} disabled={loading}>
//                             {loading ? "Sending..." : "Submit"}
//                         </button>
//                         <div style={{ marginTop: "10px", textAlign: "center" }}>
//                             <span onClick={() => setIsForgot(false)} style={{ color: "#007bff", fontSize: "14px", cursor: "pointer" }}>Back to Login</span>
//                         </div>
//                         {message && <p style={{ marginTop: "12px", color: "red", textAlign: "center" }}>{message}</p>}
//                     </form>
//                 )}

//                 {message && !isForgot && (
//                     <div style={{ marginTop: "15px", padding: "10px", borderRadius: "6px", textAlign: "center", color: message.includes("successfully") ? "green" : "red", fontWeight: "bold" }}>
//                         {message}
//                     </div>
//                 )}

//                 {isSignup && (
//                     <>
//                         <div style={{ display: "flex", gap: "20px", justifyContent: "center", marginBottom: "10px" }}>
//                             <label><input type="radio" name="signupType" value="personal" checked={signupType === "personal"} onChange={() => setSignupType("personal")} /> Personal</label>
//                             <label><input type="radio" name="signupType" value="professional" checked={signupType === "professional"} onChange={() => setSignupType("professional")} /> Professional</label>
//                         </div>
//                         <form onSubmit={handleSignup} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
//                             <input type="text" name="userName" placeholder="Name" value={loginObj.userName} onChange={handleChange} style={{ padding: "10px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "6px" }} />
//                             <input type="email" name="emailId" placeholder="Email" value={loginObj.emailId} onChange={handleChange} style={{ padding: "10px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "6px" }} />
//                             <input type="text" name="mobileNumber" placeholder="Phone Number" value={loginObj.mobileNumber} onChange={handleChange} style={{ padding: "10px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "6px" }} />
//                             {signupType === "professional" && (
//                                 <input type="text" name="companyName" placeholder="Company Name" value={loginObj.companyName} onChange={handleChange} style={{ padding: "10px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "6px" }} />
//                             )}
//                             <div style={{ position: "relative", width: "100%" }}>
//                                 <input type={showPassword ? "text" : "password"} name="password" placeholder="Create Password" value={loginObj.password} onChange={handleChange}
//                                     style={{ padding: "10px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "6px", width: "100%", boxSizing: "border-box" }} />
//                                 <span onClick={() => setShowPassword(!showPassword)} style={{ position: "absolute", top: "50%", right: "10px", transform: "translateY(-50%)", cursor: "pointer", color: "#888" }}>
//                                     {showPassword ? <FaEyeSlash /> : <FaEye />}
//                                 </span>
//                             </div>
//                             <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px", fontSize: "14px" }}>
//                                 <input type="checkbox" checked={termsAccepted} onChange={(e) => setTermsAccepted(e.target.checked)} />
//                                 <span>I hereby agree to the</span>
//                                 <a href="/Termscondition" style={{ color: "#007bff", textDecoration: "none" }}>Terms & Conditions</a>
//                                 <span>and</span>
//                                 <a href="/privacy-policys" target="_blank" rel="noopener noreferrer" style={{ color: "#007bff", textDecoration: "none" }}>Privacy Policy</a>
//                                 <span>of Maamaas</span>
//                             </div>
//                             <button type="submit" disabled={!termsAccepted || isLoading}
//                                 style={{ backgroundColor: !termsAccepted ? "gray" : "#ee6521", color: "white", fontWeight: "bold", padding: "12px", border: "none", borderRadius: "6px", cursor: !termsAccepted ? "not-allowed" : "pointer" }}>
//                                 {isLoading ? "Signing up..." : "SIGN UP"}
//                             </button>
//                             {error && <div style={{ color: "red", marginTop: "10px" }}>{error}</div>}
//                         </form>
//                     </>
//                 )}
// {showOtpPopup && (
//     <div
//         style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             background: "rgba(0,0,0,0.5)",
//             backdropFilter: "blur(6px)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 9999,
//             animation: "fadeIn 0.3s ease"
//         }}
//     >
//         <div
//             style={{
//                 background: "#fff",
//                 padding: "25px",
//                 borderRadius: "12px",
//                 width: "320px",
//                 textAlign: "center",
//                 boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
//                 transform: "scale(0.9)",
//                 animation: "popupScale 0.3s ease forwards"
//             }}
//         >
//             <h3 style={{ marginBottom: "10px" }}>🔐 Verify OTP</h3>

//             <p style={{ fontSize: "14px", color: "#666" }}>
//                 Enter OTP sent to your mobile
//             </p>

//             <input
//                 type="text"
//                 maxLength={6}
//                 value={otp}
//                 onChange={(e) => setOtp(e.target.value)}
//                 placeholder="Enter 6-digit OTP"
//                 style={{
//                     padding: "12px",
//                     width: "100%",
//                     margin: "15px 0",
//                     border: "1px solid #ccc",
//                     borderRadius: "8px",
//                     textAlign: "center",
//                     fontSize: "18px",
//                     letterSpacing: "4px"
//                 }}
//             />

//             <button
//     onClick={handleVerifyOtp}
//     disabled={isVerifying}
//     style={{
//         background: isVerifying ? "#999" : "#ee6521",
//         color: "#fff",
//         padding: "12px",
//         border: "none",
//         borderRadius: "8px",
//         width: "100%",
//         fontWeight: "bold",
//         cursor: isVerifying ? "not-allowed" : "pointer",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         gap: "10px"
//     }}
// >
//     {isVerifying ? (
//         <>
//             <span className="spinner"></span>
//             Verifying...
//         </>
//     ) : (
//         "Verify OTP"
//     )}
// </button>

//             <button
//                 onClick={handleResendOtp}
//                 style={{
//                     marginTop: "10px",
//                     background: "transparent",
//                     color: "#007bff",
//                     border: "none",
//                     cursor: "pointer"
//                 }}
//             >
//                 Resend OTP
//             </button>

//             <button
//                 onClick={() => setShowOtpPopup(false)}
//                 style={{
//                     marginTop: "10px",
//                     background: "#ccc",
//                     color: "#000",
//                     padding: "8px",
//                     border: "none",
//                     borderRadius: "6px",
//                     width: "100%"
//                 }}
//             >
//                 Cancel
//             </button>
//         </div>
//     </div>
// )}
//                 {!isForgot && (
//                     <div style={{ textAlign: "center" }}>
//                         <p style={{ fontSize: "14px" }}>
//                             {isSignup ? "Already have an account?" : "Don't have an account?"}{" "}
//                             <span onClick={() => { setIsSignup(!isSignup); setIsForgot(false); }} style={{ color: "#ee6521", fontWeight: "bold", cursor: "pointer" }}>
//                                 {isSignup ? "Login here" : "Sign up"}
//                             </span>
//                         </p>
//                     </div>
//                 )}
//             </div>

//             {showContainer && (
//                 <>
//                     <Slide direction="down" in={true} mountOnEnter unmountOnExit>
//                         <Paper sx={{ position: "fixed", top: "60px", right: "10px", width: "150px", backgroundColor: "white", boxShadow: "0px 4px 12px rgba(0,0,0,0.15)", borderRadius: "10px", zIndex: 1000, overflow: "auto" }}>
//                             <MenuItem onClick={handleLogout} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", fontSize: "15px", fontWeight: 500 }}>
//                                 Logout <LogoutIcon fontSize="small" />
//                             </MenuItem>
//                             {/* <MenuItem onClick={handleProfile} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", fontSize: "15px", fontWeight: 500 }}>
//                                 Profile <PersonIcon fontSize="small" />
//                             </MenuItem> */}
//                         </Paper>
//                     </Slide>
//                     <style>{`@keyframes fadeIn { from { opacity: 0; transform: translateY(-4px); } to { opacity: 1; transform: translateY(0); } }`}</style>
//                 </>
//             )}
//         </>
//     );
// }




import React, { useState, useEffect, useRef } from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaBars, FaTimes } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import logo from "../pages/modules/Component/maamaaslog.png";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Link } from 'react-router-dom';
import SliderComponent from '../pages/modules/Cloudkitchen/SliderComponent.js';
import { Paper, MenuItem, Slide, IconButton } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import { FaMapMarkerAlt } from "react-icons/fa";
import { FaSearch } from "react-icons/fa";
import { useParams } from "react-router-dom";

const getStorageKeys = (userId) => ({
    SAVED_KEY: `savedAddresses_${userId}`,
    CURRENT_KEY: `currentLocation_${userId}`,
    SELECTED_KEY: `selectedAddress_${userId}`,
});

export default function Cloudnavbar({ showLogin, setShowLogin }) {
    const [index, setIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [scrolled, setScrolled] = useState(false);
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [showForgetPassword, setShowForgetPassword] = useState(false);
    const [isForgot, setIsForgot] = useState(false);
    const [loginObj, setLoginObj] = useState({ userName: "", password: "" });
    const [showPassword, setShowPassword] = useState(false);
    const [hidePassword, setHidePassword] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const [showPasswordFields, setShowPasswordFields] = useState(false);
    const [forgotEmail, setForgotEmail] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [isSignup, setIsSignup] = useState(false);
    const [isEmailSubmitted, setIsEmailSubmitted] = useState(false);
    const [loginStepStarted, setLoginStepStarted] = useState(false);
    const [emailCheckMessage, setEmailCheckMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [cartCount, setCartCount] = useState(0);
    const [signupType, setSignupType] = useState("personal");
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [showContainer, setShowContainer] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isLoginOpen, setIsLoginOpen] = useState(false);
    const GOOGLE_API_KEY = "";
    const [userLocation, setUserLocation] = useState("");
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);

    const [savedAddresses, setSavedAddresses] = useState(() => {
        const data = localStorage.getItem("savedAddresses");
        return data ? JSON.parse(data) : [];
    });

    const { vendorId } = useParams();

    const [showLocationPopup, setShowLocationPopup] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [isLocating, setIsLocating] = useState(false);
    const [locationError, setLocationError] = useState("");
    const [showMapPopup, setShowMapPopup] = useState(false);
    const [mapSelectedLocation, setMapSelectedLocation] = useState(null);
    const [mapAddress, setMapAddress] = useState("");
    const [addressTitle, setAddressTitle] = useState("");
    const [isMapLoading, setIsMapLoading] = useState(false);
    const [showMobileSearch, setShowMobileSearch] = useState(false);
    const [showOtpPopup, setShowOtpPopup] = useState(false);
    const [otp, setOtp] = useState("");
    const mapRef = useRef(null);

    const openLoginDrawer = () => setIsLoginOpen(true);
    const closeLoginDrawer = () => setIsLoginOpen(false);

    const userId = localStorage.getItem("userId");

    const { SAVED_KEY, CURRENT_KEY, SELECTED_KEY } = getStorageKeys(userId);

    const dispatchLocationUpdated = () => {
        window.dispatchEvent(new Event("storage"));
        window.dispatchEvent(new CustomEvent("locationUpdated"));
    };

    useEffect(() => {
        if (isSignup) {
            setIsSignup(true);
            setShowLogin(true);
        }
    }, [isSignup]);

    useEffect(() => {
        let timeoutId;
        if (showContainer) {
            timeoutId = setTimeout(() => setShowContainer(false), 4000);
        }
        return () => { if (timeoutId) clearTimeout(timeoutId); };
    }, [showContainer]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const profileIcon = document.querySelector('[data-profile-icon]');
            const dropdown = document.querySelector('[data-profile-dropdown]');
            if (
                showContainer &&
                profileIcon &&
                dropdown &&
                !profileIcon.contains(event.target) &&
                !dropdown.contains(event.target)
            ) {
                setShowContainer(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [showContainer]);

    function handleSignInClick() { setShowLogin(true); }

    const handleProfile = () => navigate("/profilepage");

    const handleLogout = () => {
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("authToken");
        localStorage.removeItem("vendorId");
        setIsLoggedIn(false);
        setShowContainer(false);
    };

    useEffect(() => {
        const token = localStorage.getItem("userToken");
        if (token) setIsLoggedIn(true);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            if (window.innerWidth > 768) setShowMobileMenu(false);
        };
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener("resize", handleResize);
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleChange = (e) => setLoginObj({ ...loginObj, [e.target.name]: e.target.value });

    const handleSignup = async (e) => {
        e.preventDefault();
        setError("");
        if (!termsAccepted) { setError("Please select Terms and Conditions"); return; }
        if (!loginObj.userName || !loginObj.emailId || !loginObj.password) {
            setError("Please fill all required fields"); return;
        }
        setIsLoading(true);
        const requestBody = {
            userName: loginObj.userName,
            emailId: loginObj.emailId,
            password: loginObj.password,
            referralCodeUsed: loginObj.referralCodeUsed || null,
            mobileNumber: loginObj.mobileNumber,
            registeredTime: new Date().toISOString(), // Auto-generated
            companyName: loginObj.companyName || null,
            role: "ROLE_USER",
            userType: signupType === "personal" ? "PERSONAL" : "PROFESSIONAL",
            termsAndConditions: termsAccepted,
        };
        try {
            const response = await fetch(
                "https://backend.maamaas.com/subscription/api/user/registration",
                { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(requestBody) }
            );
            let result;
            try { result = JSON.parse(await response.text()); } catch { result = {}; }
            if (response.ok) {
                alert("Signup successful! Please verify OTP");
                setShowOtpPopup(true);
            } else {
                setError(result.message || "Signup failed");
            }
        } catch (error) {
            setError("Something went wrong. Please try again.");
        }
        setIsLoading(false);
    };

    const handleVerifyOtp = async () => {
        if (!otp) {
            setError("Please enter OTP");
            return;
        }
        setIsVerifying(true);
        try {
            const response = await fetch(
                `https://backend.maamaas.com/subscription/api/user/registration/verifyotp?mobile=${loginObj.mobileNumber}&otp=${otp}`,
                { method: "POST" }
            );

            const text = await response.text();

            let result;
            try {
                result = JSON.parse(text);
            } catch {
                result = { message: text };
            }

            if (response.ok) {
                alert("✅ OTP Verified Successfully!");
                setShowOtpPopup(false);
                setIsSignup(false);
            } else {
                setError(result.message || text);
            }

        } catch (err) {
            setError("Something went wrong");
        }
        setIsVerifying(false);
    };

    const handleResendOtp = async () => {
        try {
            await fetch(
                `https://backend.maamaas.com/subscription/api/user/resendotp?mobile=${loginObj.mobileNumber}`,
                { method: "POST" }
            );
            alert("OTP Sent Again");
        } catch {
            setError("Failed to resend OTP");
        }
    };

    const handleChanges = (e) => {
        const { name, value } = e.target;
        setLoginObj((prev) => ({ ...prev, [name]: value }));
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");
        try {
            const url = `https://backend.maamaas.com/subscription/api/auth/login/user?identifier=${encodeURIComponent(loginObj.identifier)}&password=${encodeURIComponent(loginObj.password)}`;
            const response = await fetch(url, { method: "POST", headers: { accept: "*/*" } });
            const text = await response.text();
            let data;
            try { data = JSON.parse(text); } catch { throw new Error("Invalid JSON response from server"); }

            if (response.ok && data.token) {
                // Save login data
                localStorage.setItem("authToken", data.token);
                localStorage.setItem("refreshToken", data.refreshToken);
                localStorage.setItem("userId", data.userId);
                localStorage.setItem("userType", data.userType || "");
                localStorage.setItem("role", data.role);
                localStorage.setItem("isLoggedIn", "true");
                localStorage.setItem("customerId", "usrUSR140520263");

                if (data.professionalUserId) {
                    localStorage.setItem("professionalUserId", data.professionalUserId);
                } else {
                    localStorage.removeItem("professionalUserId");
                }

                // ========== ADD THIS: Set login timestamp for this user ==========
                const userId = data.userId;
                const loginTimestamp = Date.now().toString();
                localStorage.setItem(`loginTimestamp_${userId}`, loginTimestamp);
                console.log(`New login timestamp for user ${userId}: ${loginTimestamp}`);
                // ========== END OF ADDED CODE ==========

                alert("Login successful!");
                setIsLoggedIn(true);
                setShowLogin(false);

                window.dispatchEvent(new Event('storage'));
                window.dispatchEvent(new CustomEvent('loginStatusChanged', { detail: { isLoggedIn: true } }));

                if (data.professionalUserId) {
                    navigate("/professional-registration");
                } else {
                    const redirectTo = localStorage.getItem("redirectAfterLogin") || "/user-dashboard";
                    navigate(redirectTo);
                }
            } else {
                setError(data.message || "Invalid credentials.");
            }
        } catch (error) {
            setError("Email or Password wrong. Please try again later.");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const checkLogin = () => {
            setIsLoggedIn(localStorage.getItem("isLoggedIn") === "true");
        };
        checkLogin();
        window.addEventListener("storage", checkLogin);
        return () => window.removeEventListener("storage", checkLogin);
    }, []);

    const togglePopup = () => setShowPopup(!showPopup);
    const toggleMobileMenu = () => setShowMobileMenu(!showMobileMenu);
    const toggleMobileSearch = () => {
        setShowMobileSearch(!showMobileSearch);
        setShowMobileMenu(false);
    };

    useEffect(() => { fetchUserSavedLocation(); }, []);

    useEffect(() => {
        const handleOpenLocationPopup = () => {
            setShowLocationPopup(true);
        };

        window.addEventListener("openLocationPopup", handleOpenLocationPopup);

        return () => {
            window.removeEventListener("openLocationPopup", handleOpenLocationPopup);
        };
    }, []);

    useEffect(() => {
        if (!userId) return;
        localStorage.setItem(SAVED_KEY, JSON.stringify(savedAddresses));
    }, [savedAddresses, userId]);

    useEffect(() => {
        if (!userId || !selectedAddress) return;
        localStorage.setItem(SELECTED_KEY, JSON.stringify(selectedAddress));
    }, [selectedAddress, userId]);

    useEffect(() => {
        if (!userId) return;
        const saved = localStorage.getItem(SAVED_KEY);
        const current = localStorage.getItem(CURRENT_KEY);
        if (saved) {
            try { setSavedAddresses(JSON.parse(saved)); } catch { }
        }
        if (current) {
            try {
                const c = JSON.parse(current);
                setSelectedAddress(c.full);
                setUserLocation({ lat: c.lat, lng: c.lng });
            } catch { }
        }
    }, [userId]);

    useEffect(() => {
        if (!showMapPopup) return;
        const loadLeaflet = () => {
            if (!window.L) {
                const script = document.createElement("script");
                script.src = "https://unpkg.com/leaflet@1.7.1/dist/leaflet.js";
                script.onload = initializeMap;
                document.body.appendChild(script);
            } else {
                initializeMap();
            }
        };
        if (!document.querySelector('link[href*="leaflet"]')) {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = "https://unpkg.com/leaflet@1.7.1/dist/leaflet.css";
            document.head.appendChild(link);
        }
        loadLeaflet();
        return () => {
            if (window.currentMap) { window.currentMap.remove(); window.currentMap = null; }
        };
    }, [showMapPopup]);

    const initializeMap = () => {
        if (!mapRef.current || !window.L) return;
        if (window.currentMap) window.currentMap.remove();
        const defaultLocation = [40.7128, -74.0060];
        const map = window.L.map(mapRef.current).setView(defaultLocation, 13);
        window.currentMap = map;
        window.L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "© OpenStreetMap contributors",
        }).addTo(map);
        map.on("click", (e) => {
            const loc = [e.latlng.lat, e.latlng.lng];
            setMapSelectedLocation(loc);
            updateMarker(loc, map);
            getAddressFromCoordinates(loc);
        });
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    const loc = [pos.coords.latitude, pos.coords.longitude];
                    map.setView(loc, 15);
                    setMapSelectedLocation(loc);
                    updateMarker(loc, map);
                    getAddressFromCoordinates(loc);
                },
                () => {
                    setMapSelectedLocation(defaultLocation);
                    updateMarker(defaultLocation, map);
                    getAddressFromCoordinates(defaultLocation);
                }
            );
        }
    };

    const updateMarker = (location, map) => {
        if (window.currentMarker) window.currentMarker.remove();
        const marker = window.L.marker(location, { draggable: true }).addTo(map);
        window.currentMarker = marker;
        marker.on("dragend", (e) => {
            const loc = [e.target.getLatLng().lat, e.target.getLatLng().lng];
            setMapSelectedLocation(loc);
            getAddressFromCoordinates(loc);
        });
    };

    const getAddressFromCoordinates = async (location) => {
        setIsMapLoading(true);
        try {
            const res = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${location[0]},${location[1]}&key=${GOOGLE_API_KEY}`
            );
            const data = await res.json();
            if (data.status === "OK" && data.results.length > 0) {
                setMapAddress(data.results[0].formatted_address);
            } else {
                setMapAddress("Address not found");
            }
        } catch (err) {
            setMapAddress("Error getting address");
        } finally {
            setIsMapLoading(false);
        }
    };

    const handleSaveAddressFromMap = async () => {
        if (!mapSelectedLocation || !mapAddress) return;

        const newAddress = {
            title: addressTitle || "Custom Location",
            full: mapAddress,
            lat: mapSelectedLocation[0],
            lng: mapSelectedLocation[1],
        };

        const currentUserId = localStorage.getItem("userId");
        const { CURRENT_KEY: CK, SELECTED_KEY: SK, SAVED_KEY: SAK } = getStorageKeys(currentUserId);

        localStorage.setItem(CK, JSON.stringify(newAddress));
        localStorage.setItem(SK, JSON.stringify(newAddress.full));

        setSavedAddresses(prev => [newAddress, ...prev]);
        setSelectedAddress(newAddress.full);
        setUserLocation({ lat: newAddress.lat, lng: newAddress.lng });

        dispatchLocationUpdated();

        const token = localStorage.getItem("authToken");
        const customerId = localStorage.getItem("customerId") || "usrUSR140520263";
        localStorage.setItem("customerId", customerId);

        if (token && currentUserId) {
            try {
                const requestBody = {
                    userId: parseInt(currentUserId),
                    customerId: customerId,
                    latitude: newAddress.lat,
                    longitude: newAddress.lng,
                    address: newAddress.full,
                    city: "",
                    category: addressTitle || "home",
                };

                await fetch(
                    "https://backend.maamaas.com/subscription/api/user/current/location/update",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify(requestBody),
                    }
                );
            } catch (error) {
                // Silent catch
            }
        }

        setShowMapPopup(false);
        setShowLocationPopup(false);
    };

    const getCurrentLocation = () => {
        if (!navigator.geolocation) {
            setLocationError("Geolocation not supported");
            return;
        }

        setIsLocating(true);
        setLocationError("");

        navigator.geolocation.getCurrentPosition(
            async (pos) => {
                const latitude = pos.coords.latitude;
                const longitude = pos.coords.longitude;

                if (latitude == null || longitude == null) {
                    setLocationError("Unable to fetch coordinates");
                    setIsLocating(false);
                    return;
                }

                let fullAddress = `Lat: ${latitude}, Lng: ${longitude}`;
                try {
                    if (GOOGLE_API_KEY) {
                        const res = await fetch(
                            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGLE_API_KEY}`
                        );
                        const data = await res.json();
                        fullAddress = data?.results?.[0]?.formatted_address || fullAddress;
                    }
                } catch (err) {
                    // Silent catch
                }

                const currentLocation = {
                    title: "Current Location",
                    full: fullAddress,
                    lat: latitude,
                    lng: longitude,
                };

                const currentUserId = localStorage.getItem("userId");
                const { CURRENT_KEY: CK, SELECTED_KEY: SK, SAVED_KEY: SAK } = getStorageKeys(currentUserId);

                localStorage.setItem(CK, JSON.stringify(currentLocation));
                localStorage.setItem(SK, JSON.stringify(fullAddress));

                setSelectedAddress(fullAddress);
                setUserLocation({ lat: latitude, lng: longitude });

                setSavedAddresses(prev => {
                    const exists = prev.some(a => a.title === "Current Location");
                    const updated = exists
                        ? prev.map(a => a.title === "Current Location" ? currentLocation : a)
                        : [currentLocation, ...prev];
                    localStorage.setItem(SAK, JSON.stringify(updated));
                    return updated;
                });

                const token = localStorage.getItem("authToken");
                const customerId = localStorage.getItem("customerId") || "usrUSR140520263";

                if (token && currentUserId) {
                    try {
                        const requestBody = {
                            userId: parseInt(currentUserId),
                            customerId: customerId,
                            latitude: latitude,
                            longitude: longitude,
                            address: fullAddress,
                            city: "",
                            category: "current_location",
                        };

                        await fetch(
                            "https://backend.maamaas.com/subscription/api/user/current/location/update",
                            {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `Bearer ${token}`,
                                },
                                body: JSON.stringify(requestBody),
                            }
                        );
                    } catch (err) {
                        // Silent catch
                    }
                }

                dispatchLocationUpdated();

                setIsLocating(false);
                setShowLocationPopup(false);
            },
            (error) => {
                let msg = "Location access denied";
                if (error.code === 2) msg = "Location unavailable";
                if (error.code === 3) msg = "Location request timeout";
                setLocationError(msg);
                setIsLocating(false);
            },
            { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
        );
    };

    const fetchUserSavedLocation = async () => {
        const token = localStorage.getItem("authToken");
        const currentUserId = localStorage.getItem("userId");

        if (!token || !currentUserId) {
            return;
        }

        try {
            const response = await fetch(
                `https://backend.maamaas.com/subscription/api/user/get/current/location/${currentUserId}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            if (!response.ok) {
                return;
            }

            const text = await response.text();
            if (!text || text.trim() === "") {
                return;
            }

            const data = JSON.parse(text);

            if (data && data.address) {
                const locationObj = {
                    title: "Saved Location",
                    full: data.address,
                    lat: data.latitude || data.lat || 0,
                    lng: data.longitude || data.lng || 0,
                };

                const { CURRENT_KEY: CK, SELECTED_KEY: SK } = getStorageKeys(currentUserId);
                localStorage.setItem(CK, JSON.stringify(locationObj));
                localStorage.setItem(SK, JSON.stringify(data.address));

                setSelectedAddress(data.address);
                setUserLocation({ lat: locationObj.lat, lng: locationObj.lng });

                if (data.customerId) {
                    localStorage.setItem("customerId", data.customerId);
                }

                dispatchLocationUpdated();
            }
        } catch (err) {
            // Silent catch
        }
    };

    const handleAddressSearch = async () => {
        if (!searchQuery.trim()) return;
        try {
            const response = await fetch(
                `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchQuery)}&limit=5`
            );
            const data = await response.json();
            if (data && data.length > 0) {
                const result = data[0];
                const address = result.display_name;
                const currentUserId = localStorage.getItem("userId");
                const locationObj = {
                    title: "Searched Location",
                    full: address,
                    lat: parseFloat(result.lat),
                    lng: parseFloat(result.lon),
                };

                const { CURRENT_KEY: CK, SELECTED_KEY: SK } = getStorageKeys(currentUserId);
                localStorage.setItem(CK, JSON.stringify(locationObj));
                localStorage.setItem(SK, JSON.stringify(address));

                setSelectedAddress(address);

                setSavedAddresses((prev) => {
                    const updated = [locationObj, ...prev];
                    const { SAVED_KEY: SAK } = getStorageKeys(currentUserId);
                    localStorage.setItem(SAK, JSON.stringify(updated));
                    return updated;
                });

                dispatchLocationUpdated();

                setShowLocationPopup(false);
                setSearchQuery("");
            } else {
                setLocationError("No addresses found for your search.");
            }
        } catch (error) {
            setLocationError("Error searching for address. Please try again.");
        }
    };

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleEmailChange = (e) => setEmail(e.target.value);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");
        if (!email) { setMessage("Please enter your email."); setLoading(false); return; }
        try {
            const response = await axios.post(
                "https://backend.maamaas.com/subscription/api/user/forget/password",
                { identifier: email }
            );
            if (response.status === 200) {
                setMessage("Reset link sent successfully to your email.");
                setIsEmailSubmitted(true);
            } else {
                setMessage("Something went wrong. Please try again.");
            }
        } catch (error) {
            setMessage(error.response?.data?.message || "Error while sending reset link. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const styles = {
        nav: {
            position: "fixed", top: 0, left: 0, width: "100%", zIndex: 100,
            padding: isMobile ? "10px 16px" : "16px 32px",
            display: "flex", justifyContent: "space-between", alignItems: "center",
            backgroundColor: scrolled ? "#ee6521" : "white", color: "#ee6521",
            backdropFilter: scrolled ? "blur(8px)" : "none",
            boxShadow: scrolled ? "0 2px 10px rgba(0,0,0,0.1)" : "none",
            transition: "all 0.4s ease", height: "65px",
        },
        logo: { display: "flex", alignItems: "center", fontSize: isMobile ? "20px" : "26px", fontWeight: "bold", color: "white", zIndex: 101 },
        navRight: {
            display: isMobile ? (showMobileMenu ? "flex" : "none") : "flex",
            flexDirection: "row", alignItems: "center", justifyContent: "space-evenly",
            gap: isMobile ? "15px" : "20px",
            position: isMobile ? "fixed" : "relative",
            top: isMobile ? "65px" : "auto", left: 0, right: 0,
            backgroundColor: isMobile ? "#fff" : "transparent",
            padding: isMobile ? "10px" : "0",
            width: isMobile ? "100%" : "auto",
            boxShadow: isMobile ? "0 5px 10px rgba(0,0,0,0.1)" : "none",
            zIndex: 100, borderRadius: "10px",
        },
        link: {
            textDecoration: "none", color: isMobile ? "#000" : "#ee6521",
            fontSize: isMobile ? "17px" : "14px", fontWeight: "bold", cursor: "pointer",
            whiteSpace: "nowrap", padding: isMobile ? "8px 0" : "0", textTransform: "uppercase",
        },
        navLinks: { display: "flex", flexDirection: "row", alignItems: "center", gap: isMobile ? "5px" : "20px", marginRight: isMobile ? "0" : "20px" },
        signInBtn: {
            padding: isMobile ? "8px 16px" : "10px 20px", backgroundColor: "orange",
            border: "none", borderRadius: "15px", color: "#ee6521", fontWeight: "600",
            cursor: "pointer", fontSize: isMobile ? "14px" : "16px", whiteSpace: "nowrap", textTransform: "uppercase",
        },
        loginForm: {
            position: "fixed", top: isMobile ? "10px" : "20px",
            right: showLogin ? "0" : "-100%",
            width: "100%", maxWidth: isMobile ? "90%" : "400px",
            backgroundColor: "white", borderRadius: "20px",
            padding: isMobile ? "20px 15px" : "40px 30px",
            boxShadow: "-5px 0 15px rgba(0, 0, 0, 0.1)",
            transition: "right 0.5s ease-in-out", zIndex: 999,
            display: "flex", flexDirection: "column", gap: "20px", overflowY: "auto", scrollbarWidth: "none",
        },
        locationWrapper: {
            display: isMobile ? "none" : "flex", alignItems: "center", gap: "12px",
            flex: 1, maxWidth: "650px", margin: "0 20px",
        },
        locationBox: {
            display: "flex", alignItems: "center", gap: "12px",
            padding: "5px 18px", backgroundColor: "#ee6521",
            borderRadius: "25px", cursor: "pointer", transition: "all 0.3s ease",
            minWidth: "280px", border: "1px solid rgba(255,255,255,0.4)",
            flexShrink: 0, fontSize: "16px", fontWeight: "600",
        },
        locationIcon: { color: "#FFD700", fontSize: "20px", flexShrink: 0 },
        locationText: {
            fontSize: "16px", fontWeight: "600", color: "white",
            whiteSpace: "nowrap", overflow: "auto", textOverflow: "ellipsis", scrollbarWidth: "none",
            maxWidth: "180px", flex: 1,
        },
        downArrow: { color: "white", fontSize: "16px", marginLeft: "4px", flexShrink: 0 },
        mobileLocationWrapper: {
            display: isMobile ? "flex" : "none", alignItems: "center",
            gap: "10px", marginLeft: "auto", marginRight: "15px",
        },
        mobileLocationIcon: {
            display: "flex", alignItems: "center", justifyContent: "center",
            padding: "10px", borderRadius: "50%", cursor: "pointer",
            transition: "all 0.3s ease", minWidth: "44px", minHeight: "44px",
        },
        locationPopupOverlay: {
            position: "fixed", top: 59, left: 0, width: "100%",
            display: "flex", justifyContent: "center", alignItems: "center",
            zIndex: 1000, padding: isMobile ? "10px" : "20px", boxSizing: "border-box",
        },
        locationPopup: {
            width: "100%", maxWidth: "500px", maxHeight: "80vh",
            backgroundColor: "white", borderRadius: "12px", padding: "20px",
            boxShadow: "0 10px 25px rgba(0,0,0,0.2)", overflowY: "auto", position: "relative", scrollbarWidth: "none",
        },
        popupHeader: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", paddingBottom: "15px", borderBottom: "1px solid #eee" },
        popupTitle: { margin: 0, fontSize: "20px", fontWeight: "600", color: "#333" },
        closePopupBtn: { background: "transparent", border: "none", fontSize: "20px", cursor: "pointer", color: "#666", padding: "5px" },
        optionBox: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "15px", backgroundColor: "#f8f9fa", borderRadius: "8px", marginBottom: "15px", cursor: "pointer", transition: "all 0.3s ease", border: "1px solid #e9ecef" },
        optionContent: { display: "flex", alignItems: "center", gap: "12px" },
        optionTitle: { margin: 0, fontSize: "16px", fontWeight: "600", color: "#333" },
        optionDesc: { margin: "4px 0 0 0", fontSize: "13px", color: "#666" },
        enableBtn: { padding: "8px 16px", backgroundColor: "#9d36ca", color: "white", border: "none", borderRadius: "6px", fontSize: "13px", fontWeight: "500", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px" },
        addAddressBox: { display: "flex", alignItems: "center", gap: "12px", padding: "15px", backgroundColor: "#f0f8ff", borderRadius: "8px", marginBottom: "20px", cursor: "pointer", transition: "all 0.3s ease", border: "1px dashed #a54dd4" },
        plusIcon: { fontSize: "18px", color: "#a551d9", fontWeight: "bold" },
        addAddressText: { fontSize: "16px", fontWeight: "500", color: "#983fc1" },
        errorMessage: { padding: "10px 15px", backgroundColor: "#ffe6e6", color: "#d63031", borderRadius: "6px", marginBottom: "15px", fontSize: "14px" },
        savedHeading: { fontSize: "16px", fontWeight: "600", color: "#333", marginBottom: "12px" },
        savedBox: { display: "flex", alignItems: "flex-start", gap: "12px", padding: "15px", backgroundColor: "#fff", borderRadius: "8px", marginBottom: "10px", cursor: "pointer", transition: "all 0.3s ease", border: "1px solid #eee" },
        savedLeft: { display: "flex", alignItems: "center", gap: "8px" },
        pinIcon: { color: "#d63031", fontSize: "16px" },
        savedTitle: { margin: 0, fontSize: "15px", fontWeight: "600", color: "#333" },
        savedAddressText: { margin: "4px 0 0 0", fontSize: "13px", color: "#666", lineHeight: "1.4" },
        loadingSpinner: { display: "inline-block", width: "12px", height: "12px", border: "2px solid transparent", borderTop: "2px solid currentColor", borderRadius: "50%", animation: "spin 1s linear infinite" },
    };

    return (
        <>
            <nav style={styles.nav}>
                <div style={styles.logo}>
                    <Link to="/" style={{ ...styles.logo, textDecoration: "none" }}>
                        <div style={{ fontSize: window.innerWidth <= 600 ? "20px" : "25px", fontWeight: "bold", fontFamily: "'Poppins', sans-serif" }}>
                            <span style={{ color: "black" }}>MAA</span>
                            <span style={{ color: "#ee6521" }}>MAAS</span>
                        </div>
                    </Link>
                </div>

                <div style={styles.locationWrapper}>
                    <div
                        style={styles.locationBox}
                        onClick={() => setShowLocationPopup(true)}
                        onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0,0,0,0.2)"; e.currentTarget.style.backgroundColor = "#ee6521"; }}
                        onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.backgroundColor = "#ee6521"; }}
                    >
                        <span style={styles.locationIcon}><FaMapMarkerAlt /></span>
                        <span style={styles.locationText}>
                            {selectedAddress
                                ? (selectedAddress.length > 25 ? selectedAddress.substring(0, 25) + "..." : selectedAddress)
                                : "Select Location"}
                        </span>
                        <span style={styles.downArrow}>▾</span>
                    </div>
                </div>

                <div style={styles.mobileLocationWrapper}>
                    <div style={styles.mobileLocationIcon} onClick={() => setShowLocationPopup(true)}>
                        <span style={styles.locationIcon}><FaMapMarkerAlt /></span>
                    </div>
                </div>

                {showLocationPopup && (
                    <div style={styles.locationPopupOverlay}>
                        <div style={styles.locationPopup}>
                            <div style={styles.popupHeader}>
                                <h2 style={styles.popupTitle}>Select Your Location</h2>
                                <button style={styles.closePopupBtn} onClick={() => { setShowLocationPopup(false); setLocationError(""); setSearchQuery(""); }}>✕</button>
                            </div>

                            <div style={styles.optionBox} onClick={getCurrentLocation}>
                                <div style={styles.optionContent}>
                                    <span style={{ color: "#FF4D4D", fontSize: "18px" }}><FaMapMarkerAlt /></span>
                                    <div>
                                        <h3 style={styles.optionTitle}>Use My Current Location</h3>
                                        <p style={styles.optionDesc}>Enable your current location for better services</p>
                                    </div>
                                </div>
                                <button style={styles.enableBtn} disabled={isLocating}>
                                    {isLocating ? <><span style={styles.loadingSpinner}></span> Locating...</> : "Detect"}
                                </button>
                            </div>

                            <div style={styles.addAddressBox} onClick={() => setShowMapPopup(true)}>
                                <span style={styles.plusIcon}>＋</span>
                                <span style={styles.addAddressText}>Add New Address on Map</span>
                            </div>

                            {locationError && <div style={styles.errorMessage}>{locationError}</div>}

                            <h3 style={styles.savedHeading}>Saved Addresses</h3>
                            {savedAddresses.map((item, index) => (
                                <div
                                    key={index}
                                    style={styles.savedBox}
                                    onClick={() => {
                                        const currentUserId = localStorage.getItem("userId");
                                        const { CURRENT_KEY: CK, SELECTED_KEY: SK } = getStorageKeys(currentUserId);
                                        localStorage.setItem(CK, JSON.stringify(item));
                                        localStorage.setItem(SK, JSON.stringify(item.full));
                                        setSelectedAddress(item.full);
                                        setUserLocation({ lat: item.lat, lng: item.lng });
                                        dispatchLocationUpdated();
                                        setShowLocationPopup(false);
                                        setLocationError("");
                                    }}
                                >
                                    <div style={styles.savedLeft}>
                                        <span style={styles.pinIcon}><FaMapMarkerAlt /></span>
                                    </div>
                                    <div>
                                        <h4 style={styles.savedTitle}>{item.title}</h4>
                                        <p style={styles.savedAddressText}>{item.full}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {showMapPopup && (
                    <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, padding: "20px", boxSizing: "border-box" }}>
                        <div style={{ width: "100%", maxWidth: "700px", height: "100vh", background: "#fff", borderRadius: "12px", display: "flex", flexDirection: "column", overflow: "auto", boxShadow: "0 10px 25px rgba(0,0,0,0.25)" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", borderBottom: "1px solid #ddd" }}>
                                <h2 style={{ margin: 0, fontSize: "18px", fontWeight: 600 }}>Select Location on Map</h2>
                                <button style={{ background: "transparent", border: "none", fontSize: "20px", cursor: "pointer" }}
                                    onClick={() => { setShowMapPopup(false); setMapSelectedLocation(null); setMapAddress(""); setAddressTitle(""); if (window.currentMap) { window.currentMap.remove(); window.currentMap = null; } }}>✕</button>
                            </div>
                            <div style={{ flex: 1, position: "relative", display: "flex", flexDirection: "column" }}>
                                <div ref={mapRef} style={{ flex: 1, width: "100%", minHeight: "300px", background: "#f0f0f0" }}>
                                    {!window.L && (
                                        <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, display: "flex", justifyContent: "center", alignItems: "center", color: "#666" }}>
                                            Loading map...
                                        </div>
                                    )}
                                </div>
                                <div style={{ padding: "12px 16px", borderTop: "1px solid #ddd", display: "flex", flexDirection: "column", gap: "10px" }}>
                                    <div style={{ minHeight: "24px", color: "#333", fontSize: "14px" }}>
                                        {isMapLoading ? "Getting address..." : mapAddress || "Click on the map to select a location"}
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="Address Title (e.g., Home, Office)"
                                        style={{ padding: "8px 10px", fontSize: "14px", borderRadius: "6px", border: "1px solid #ccc", width: "100%", boxSizing: "border-box" }}
                                        value={addressTitle}
                                        onChange={(e) => setAddressTitle(e.target.value)}
                                    />
                                    <button
                                        style={{ padding: "10px 0", fontSize: "16px", borderRadius: "6px", border: "none", background: mapSelectedLocation && mapAddress ? "#ff0054" : "#ccc", color: "#fff", cursor: mapSelectedLocation && mapAddress ? "pointer" : "not-allowed" }}
                                        disabled={!mapSelectedLocation || !mapAddress}
                                        onClick={handleSaveAddressFromMap}
                                    >
                                        Save Address
                                    </button>
                                </div>
                            </div>
                        </div>
                        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                    </div>
                )}

                {isMobile ? (
                    isLoggedIn ? (
                        <div style={{ display: "flex", border: "2px solid #ee6521", padding: "6px 16px", borderRadius: "25px", color: "#ee6521", cursor: "pointer", alignItems: "center" }} onClick={() => setShowContainer(!showContainer)}>
                            <AccountCircleIcon sx={{ fontSize: 22, color: "#ee6521" }} />
                        </div>
                    ) : (
                        <div style={{ display: "flex", border: "2px solid #ee6521", padding: "6px 16px", borderRadius: "25px", cursor: "pointer", fontWeight: "600", color: "#ee6521", alignItems: "center", justifyContent: "center" }} onClick={() => setShowLogin(true)}>
                            Sign In
                        </div>
                    )
                ) : null}

                <div style={styles.navRight}>
                    <div style={{ ...styles.navLinks, display: isMobile ? "none" : "flex" }}>
                        <a href="https://partners.maamaas.com/" target="_blank" rel="noopener noreferrer"
                            style={{ ...styles.link, border: "2px solid #ee6521", padding: "6px 16px", borderRadius: "25px", fontWeight: "600" }}
                            onMouseEnter={(e) => { e.target.style.backgroundColor = "white"; e.target.style.color = "#ff6600"; }}
                            onMouseLeave={(e) => { e.target.style.backgroundColor = "#ee6521"; e.target.style.color = "white"; }}>
                            PARTNERS
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.maamaas.app" target="_blank" rel="noopener noreferrer"
                            style={{ ...styles.link, border: "2px solid #ee6521", padding: "6px 16px", borderRadius: "25px", fontWeight: "600" }}
                            onMouseEnter={(e) => { e.target.style.backgroundColor = "white"; e.target.style.color = "#ff6600"; }}
                            onMouseLeave={(e) => { e.target.style.backgroundColor = "#ee6521"; e.target.style.color = "white"; }}>
                            Download App
                        </a>
                    </div>

                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        {isLoggedIn ? (
                            <div style={{ border: isMobile ? "2px solid black" : "2px solid #ee6521", padding: "6px 16px", borderRadius: "25px", display: "flex", alignItems: "center", cursor: "pointer", color: isMobile ? "black" : "white" }}
                                onClick={() => setShowContainer(!showContainer)}>
                                <AccountCircleIcon sx={{ fontSize: "22px", color: isMobile ? "black" : "#ee6521" }} />
                            </div>
                        ) : (
                            <SliderComponent setShowLogin={setShowLogin} isMobile={isMobile} isLoggedIn={isLoggedIn} />
                        )}
                    </div>
                </div>
            </nav>

            <div style={styles.loginForm}>
                <button style={{ position: "absolute", top: "15px", right: "20px", fontSize: "28px", background: "none", border: "none", color: "#333", cursor: "pointer" }}
                    onClick={() => { setShowLogin(false); setIsForgot(false); setIsSignup(false); }}>
                    &times;
                </button>
                <p style={{ marginBottom: 0, fontFamily: "revert", fontSize: isMobile ? "18px" : "22px", color: "#6f21b4", fontWeight: "bold" }}>
                    WELCOME TO MAAMAA'S
                </p>

                {!isSignup && !isForgot && (
                    <form onSubmit={handleLogin} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        <input type="text" placeholder="Email or Mobile Number" name="identifier" value={loginObj.identifier} onChange={handleChanges}
                            style={{ padding: "10px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "6px" }} />
                        <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
                            <input type={showPassword ? "text" : "password"} placeholder="Password" name="password" value={loginObj.password} onChange={handleChanges}
                                style={{ padding: "10px", paddingRight: "40px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "6px", width: "100%", boxSizing: "border-box" }} />
                            <span onClick={() => setShowPassword(!showPassword)} style={{ position: "absolute", top: "50%", right: "10px", transform: "translateY(-50%)", cursor: "pointer", color: "#888" }}>
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>
                        <div style={{ textAlign: "right" }}>
                            <span onClick={() => setIsForgot(true)} style={{ color: "#007bff", fontSize: "14px", cursor: "pointer" }}>Forget Password?</span>
                        </div>
                        {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}
                        <button type="submit" style={{ backgroundColor: "#ee6521", color: "white", fontWeight: "bold", padding: "12px", border: "none", borderRadius: "6px", cursor: "pointer" }} disabled={isLoading}>
                            {isLoading ? "Logging in..." : "LOGIN"}
                        </button>
                    </form>
                )}

                {isForgot && !isEmailSubmitted && (
                    <form onSubmit={handleSubmit}>
                        <input type="email" placeholder="Enter your email" value={email} onChange={handleEmailChange} required
                            style={{ padding: "10px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "6px", marginBottom: "10px", width: "100%" }} />
                        <button type="submit" style={{ backgroundColor: "#ee6521", color: "white", fontWeight: "bold", padding: "12px", border: "none", borderRadius: "6px", cursor: "pointer", width: "100%" }} disabled={loading}>
                            {loading ? "Sending..." : "Submit"}
                        </button>
                        <div style={{ marginTop: "10px", textAlign: "center" }}>
                            <span onClick={() => setIsForgot(false)} style={{ color: "#007bff", fontSize: "14px", cursor: "pointer" }}>Back to Login</span>
                        </div>
                        {message && <p style={{ marginTop: "12px", color: "red", textAlign: "center" }}>{message}</p>}
                    </form>
                )}

                {message && !isForgot && (
                    <div style={{ marginTop: "15px", padding: "10px", borderRadius: "6px", textAlign: "center", color: message.includes("successfully") ? "green" : "red", fontWeight: "bold" }}>
                        {message}
                    </div>
                )}

                {isSignup && (
                    <>
                        <div style={{ display: "flex", gap: "20px", justifyContent: "center", marginBottom: "10px" }}>
                            <label><input type="radio" name="signupType" value="personal" checked={signupType === "personal"} onChange={() => setSignupType("personal")} /> Personal</label>
                            <label><input type="radio" name="signupType" value="professional" checked={signupType === "professional"} onChange={() => setSignupType("professional")} /> Professional</label>
                        </div>
                        <form onSubmit={handleSignup} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            <input type="text" name="userName" placeholder="Name" value={loginObj.userName} onChange={handleChange} style={{ padding: "10px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "6px" }} />
                            <input type="email" name="emailId" placeholder="Email" value={loginObj.emailId} onChange={handleChange} style={{ padding: "10px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "6px" }} />
                            <input type="text" name="mobileNumber" placeholder="Phone Number" value={loginObj.mobileNumber} onChange={handleChange} style={{ padding: "10px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "6px" }} />
                            {signupType === "professional" && (
                                <input type="text" name="companyName" placeholder="Company Name" value={loginObj.companyName} onChange={handleChange} style={{ padding: "10px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "6px" }} />
                            )}
                            <div style={{ position: "relative", width: "100%" }}>
                                <input type={showPassword ? "text" : "password"} name="password" placeholder="Create Password" value={loginObj.password} onChange={handleChange}
                                    style={{ padding: "10px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "6px", width: "100%", boxSizing: "border-box" }} />
                                <span onClick={() => setShowPassword(!showPassword)} style={{ position: "absolute", top: "50%", right: "10px", transform: "translateY(-50%)", cursor: "pointer", color: "#888" }}>
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px", fontSize: "14px" }}>
                                <input type="checkbox" checked={termsAccepted} onChange={(e) => setTermsAccepted(e.target.checked)} />
                                <span>I hereby agree to the</span>
                                <a href="/Termscondition" style={{ color: "#007bff", textDecoration: "none" }}>Terms & Conditions</a>
                                <span>and</span>
                                <a href="/privacy-policys" target="_blank" rel="noopener noreferrer" style={{ color: "#007bff", textDecoration: "none" }}>Privacy Policy</a>
                                <span>of Maamaas</span>
                            </div>
                            <input
                                type="hidden"
                                name="registeredTime"
                                value={new Date().toISOString()}
                            />
                            <button type="submit" disabled={!termsAccepted || isLoading}
                                style={{ backgroundColor: !termsAccepted ? "gray" : "#ee6521", color: "white", fontWeight: "bold", padding: "12px", border: "none", borderRadius: "6px", cursor: !termsAccepted ? "not-allowed" : "pointer" }}>
                                {isLoading ? "Signing up..." : "SIGN UP"}
                            </button>
                            {error && <div style={{ color: "red", marginTop: "10px" }}>{error}</div>}
                        </form>
                    </>
                )}

                {showOtpPopup && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(0,0,0,0.5)",
                            backdropFilter: "blur(6px)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 9999,
                            animation: "fadeIn 0.3s ease"
                        }}
                    >
                        <div
                            style={{
                                background: "#fff",
                                padding: "25px",
                                borderRadius: "12px",
                                width: "320px",
                                textAlign: "center",
                                boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                                transform: "scale(0.9)",
                                animation: "popupScale 0.3s ease forwards"
                            }}
                        >
                            <h3 style={{ marginBottom: "10px" }}>🔐 Verify OTP</h3>

                            <p style={{ fontSize: "14px", color: "#666" }}>
                                Enter OTP sent to your mobile
                            </p>

                            <input
                                type="text"
                                maxLength={6}
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                                placeholder="Enter 6-digit OTP"
                                style={{
                                    padding: "12px",
                                    width: "100%",
                                    margin: "15px 0",
                                    border: "1px solid #ccc",
                                    borderRadius: "8px",
                                    textAlign: "center",
                                    fontSize: "18px",
                                    letterSpacing: "4px"
                                }}
                            />

                            <button
                                onClick={handleVerifyOtp}
                                disabled={isVerifying}
                                style={{
                                    background: isVerifying ? "#999" : "#ee6521",
                                    color: "#fff",
                                    padding: "12px",
                                    border: "none",
                                    borderRadius: "8px",
                                    width: "100%",
                                    fontWeight: "bold",
                                    cursor: isVerifying ? "not-allowed" : "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "10px"
                                }}
                            >
                                {isVerifying ? (
                                    <>
                                        <span className="spinner"></span>
                                        Verifying...
                                    </>
                                ) : (
                                    "Verify OTP"
                                )}
                            </button>

                            <button
                                onClick={handleResendOtp}
                                style={{
                                    marginTop: "10px",
                                    background: "transparent",
                                    color: "#007bff",
                                    border: "none",
                                    cursor: "pointer"
                                }}
                            >
                                Resend OTP
                            </button>

                            <button
                                onClick={() => setShowOtpPopup(false)}
                                style={{
                                    marginTop: "10px",
                                    background: "#ccc",
                                    color: "#000",
                                    padding: "8px",
                                    border: "none",
                                    borderRadius: "6px",
                                    width: "100%"
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                )}

                {!isForgot && (
                    <div style={{ textAlign: "center" }}>
                        <p style={{ fontSize: "14px" }}>
                            {isSignup ? "Already have an account?" : "Don't have an account?"}{" "}
                            <span onClick={() => { setIsSignup(!isSignup); setIsForgot(false); }} style={{ color: "#ee6521", fontWeight: "bold", cursor: "pointer" }}>
                                {isSignup ? "Login here" : "Sign up"}
                            </span>
                        </p>
                    </div>
                )}
            </div>

            {showContainer && (
                <>
                    <Slide direction="down" in={true} mountOnEnter unmountOnExit>
                        <Paper sx={{ position: "fixed", top: "60px", right: "10px", width: "150px", backgroundColor: "white", boxShadow: "0px 4px 12px rgba(0,0,0,0.15)", borderRadius: "10px", zIndex: 1000, overflow: "auto" }}>
                            <MenuItem onClick={handleLogout} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", fontSize: "15px", fontWeight: 500 }}>
                                Logout <LogoutIcon fontSize="small" />
                            </MenuItem>
                        </Paper>
                    </Slide>
                    <style>{`@keyframes fadeIn { from { opacity: 0; transform: translateY(-4px); } to { opacity: 1; transform: translateY(0); } }`}</style>
                </>
            )}
        </>
    );
}